export const formatDateTimeStamp = (date) => {
    return new Date(date).toLocaleString("en-GB", {
        weekday: "long", // optional: to display weekday
        year: "numeric",
        month: "short", // short format for the month
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // optional: set true for 12-hour format (AM/PM)
    });
};


export const formatedDateIST = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
};